import { useNavigate } from 'react-router-dom';

import { Paragraph2, SmallText } from 'inpock-ui-react';

import { thumbnail } from '@/utils';
import { Image, Rating } from '@/components/common';
import { MarketReview as MarketReviewType } from '@/apis';

import * as S from './styled';

export function MarketReview({ review, version }: { review: MarketReviewType; version?: string }) {
  const navigate = useNavigate();
  const isNew =
    new Date(review.created_at).getDate() === new Date().getDate() &&
    new Date(review.created_at).getMonth() === new Date().getMonth() &&
    new Date(review.created_at).getFullYear() === new Date().getFullYear();

  const onClickMarketReview = () => {
    const url = version
      ? `/${version}/products/${review.campaign_id}?tab=review`
      : `/products/${review.campaign_id}?tab=review`;
    navigate(url);
  };

  return (
    <S.MarketReviewWrapper onClick={onClickMarketReview}>
      <S.MarketReviewContainer>
        <Image
          lazy
          src={thumbnail.origin(review.medias[0].url)}
          borderRadius={8}
          style={{ position: 'absolute' }}
          alt={review.campaign_name}
        />
        {isNew && (
          <S.ImgBadge>
            <SmallText className="text-white text-bold">N</SmallText>
          </S.ImgBadge>
        )}
      </S.MarketReviewContainer>
      <S.ReviewInfoContainer>
        <div className="d-flex" style={{ gap: '4px' }}>
          <Rating rating={review.rating} size={12} gap={2} color="#f04400" />
          <SmallText color="gray800">{review.rating}</SmallText>
        </div>
        <S.ProductTitle color="gray400">{review.campaign_name}</S.ProductTitle>
        <S.ReviewContent>
          <Paragraph2>{review.contents}</Paragraph2>
        </S.ReviewContent>
      </S.ReviewInfoContainer>
    </S.MarketReviewWrapper>
  );
}
